import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import LayoutMixin from '@/views/dashboard/mixins/layout';
import template from '@/../templates/dashboard/widgets/devicegroup.hbs';


    var DevicegroupInfoWidget = Marionette.View.extend(LayoutMixin).extend({
        className: function(){ return "devicegroup widget " + this.getWidth(); },
        ui: {
            tooltips: '[data-toggle="tooltip"]',
            owner: '.owner',
            product: '.product'
        },
        template: Handlebars.compile(template),
        modelEvents: {
            'change': 'render'
        },
        onRender: function(){
            this.ui.tooltips.tooltip();
        },
        templateContext: function() {
            var owner = this.model.rel.get('owner');
            var product = this.model.rel.get('product');
            var data = {
                owner : {
                    name: owner.get('username'),
                    id: owner.id
                },
                product : {
                    name: product.get('name'),
                    id: product.id
                },
                type : this.model.type_readable(),
                target_os: this.model.get('target_os') || 'unknown'
            };
            return data;

        }
    });

    export default DevicegroupInfoWidget;



